/**
 * ********************************************************************************************************************
 * Responsibility - Displays a list of orders within an invoice in the form of a table. 🐺
 * ****************************************************************************************
 *
 * @format
 */

import {InvoiceActionColumn} from './table_columns/invoice_action_column';
import {useActiveOrdersContext} from '../active_orders_context_provider';
import {InvoiceIdColumn} from './table_columns/invoice_id_column';
import {ActiveOrdersList} from './orders_list/orders_list';
import DateTime from 'frontier/utilities/format/date';
import Currency from '../../../../utilities/currency';
import {Table} from '@sttark/design-system';
import React from 'react';

// styles
import './invoices_list.scss';

const columns = [
    {
        key: 'invoice_id',
        title: 'Invoice',
        index: 'invoice_id'
    },
    {
        key: 'date',
        title: 'Date',
        index: 'date'
    },
    {
        key: 'total_orders',
        title: 'Contains',
        index: 'total_orders'
    },
    {
        key: 'total',
        title: 'Invoice Total',
        index: 'total'
    },
    {
        key: 'action',
        title: '',
        index: 'action'
    }
];

export const InvoicesList = props => {
    const {state} = useActiveOrdersContext();
    const {carts} = state;

    const rows = carts.map(cart => {
        return {
            invoice_id: <InvoiceIdColumn cart={cart} />,
            date: (
                <span className="orders-list-table-active-31cs__column--date">
                    {DateTime(cart.created)}
                </span>
            ),
            total_orders: (
                <span>
                    {cart.orders.length} {cart.orders.length > 1 ? 'Orders' : 'Order'}
                </span>
            ),
            total: (
                <h5 className="m-0">
                    <Currency
                        value={cart.total}
                        style={{fontSize: '16px'}}
                        thousandSeparator={true}
                    />
                </h5>
            ),
            action: <InvoiceActionColumn cart={cart} />,
            renderData: cart,
            key: cart.id
        };
    });

    return (
        <div className="orders-list-table-active-31cm">
            <Table columns={columns} rows={rows} isExpandable defaultExpanded>
                <ActiveOrdersList className="orders-list-table-active-31cm__order" />
            </Table>
        </div>
    );
};
